import React from 'react';
import './LoadingIndicator.scss';

var LoadingIndicator = function LoadingIndicator() {
  return React.createElement('div', {
    className: 'loading-indicator-fading-circle'
  }, React.createElement('div', {
    className: 'loading-indicator-circle1 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle2 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle3 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle4 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle5 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle6 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle7 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle8 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle9 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle10 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle11 loading-indicator-circle'
  }), React.createElement('div', {
    className: 'loading-indicator-circle12 loading-indicator-circle'
  }));
};

export default LoadingIndicator;